import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("errorTracking");

export const errorTrackingTransport = transport;
export const ERROR_TRACKING_BASE_URL = baseUrl;
